export default __webpack_public_path__ + "static/media/Cancel Block_Dark.49f3524f.svg";